import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IconChevronDown, } from '@tabler/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import EntityMessagesDetails from 'src/components/reservations/new-reservations/hotel/hotel-details/hotel-room-details/hotel-room-type-item-details/EntityMessagesDetails';
import ChildCard from 'src/components/shared/ChildCard';
import FallbackTypography from 'src/components/shared/FallbackTypography';
import { getUniqueMessages, getUnitMessages } from 'src/utils/hotelMessageUtils';

const ViewServiceReservationInfo = ({ item }) => {
    const { reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
    const service = reservationOverview?.Services?.find(h => h.ItemReference === item.ItemReference);
    return (
        <Grid container justifyContent="center" p={2}>
            {service?.Units?.length > 0 ? (
                <>
                    <Grid container size={{ xs: 12 }} px={4} justifyContent="space-between" >
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Service Type</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Passenger Count</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Discount</Typography>
                        </Grid>
                        <Grid size={{ xs: 4, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Description</Typography>
                        </Grid>
                        <Grid size={{ xs: 2, md: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>Supplements</Typography>
                        </Grid>
                    </Grid>

                    {/* Service Details */}
                    {service.Units.map((unit, index) => {
                        const unitMessages = getUniqueMessages(getUnitMessages(unit, service));

                        return (
                            <ChildCard key={`unit-${index}`}>
                                <Grid container spacing={8} justifyContent="space-between" mr={8}>
                                    {/* Unit Name */}
                                    <Grid size={{ xs: 2 }} lg={2}>
                                        <FallbackTypography variant="body2" value={unit.UnitName} />
                                    </Grid>
                                    {/* Unit Type */}
                                    <Grid size={{ xs: 2 }} lg={2} display="inline-flex">
                                        <FallbackTypography variant="body2" value={` (${unit.Adults} x Adults) x `} /> <FallbackTypography variant="body2" value={`(${unit.UnitCount} x Units)`} />
                                    </Grid>
                                    {/* Discount */}
                                    <Grid size={{ xs: 2 }} sm={2} lg={2}>
                                        {unit?.Discounts?.length > 0 ? (
                                            unit.Discounts.map((d, idx) => (
                                                <FallbackTypography key={`discount-${idx}`} variant="body2" value={d.Name} />
                                            ))
                                        ) : (
                                            <FallbackTypography variant="body2" value={null} />
                                        )}
                                    </Grid>
                                    {/* Description */}
                                    <Grid size={{ xs: 4, md: 2 }} lg={3}>
                                        {unit?.Discounts?.length > 0 ? (
                                            unit.Discounts.map((d, idx) => (
                                                <FallbackTypography key={`desc-${idx}`} variant="body2" value={d.Description} />
                                            ))
                                        ) : (
                                            <FallbackTypography variant="body2" value={null} />
                                        )}
                                    </Grid>
                                    {/* Supplements */}
                                    <Grid size={{ xs: 2 }} lg={1}>
                                        {unit?.Supplements?.length > 0 ? (
                                            unit.Supplements.map((s, idx) => (
                                                <FallbackTypography key={`supp-${idx}`} variant="body2" value={s.Name} />
                                            ))
                                        ) : (
                                            <FallbackTypography variant="body2" value={null} />
                                        )}
                                    </Grid>
                                </Grid>

                                {/* Service Messages*/}
                                {unitMessages.length > 0 && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<IconChevronDown />}
                                            aria-controls={`panel-${index}-content`}
                                            id={`panel-${index}-header`}
                                        >
                                            <Typography variant="body2" fontWeight="bold">
                                                Service Messages
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <EntityMessagesDetails
                                                messages={unitMessages}
                                                overviewScreen={true}
                                            />
                                        </AccordionDetails>
                                    </Accordion>
                                )}
                            </ChildCard>
                        );
                    })}
                </>
            ) : (
                <Grid item xs={12}>
                    <Typography variant="body2">No units selected.</Typography>
                </Grid>
            )}
        </Grid>
    )
}

export default ViewServiceReservationInfo